module.exports = __webpack_public_path__ + "media/blog_dark_mode_julio.1bb2e015.mp4";